/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

const assetPaths = {
  images: {
    barcodeMarker: require('./images/barcode-marker.png'),
    cod: require('./images/cod.png'),
    emptyImage: require('./images/empty_image.png'),
    iconNew: require('./images/icon-new.png'),
    iconCodBlue: require('./images/icon_cod_blue.png'),
    iconCodGray: require('./images/icon_cod_gray.png'),
    iconLazadaRound: require('./images/icon_lazada_round.png'),
    iconShopeeRound: require('./images/icon_shopee_round.png'),
    iconXsellyRound: require('./images/icon_xselly_round.png'),
    logo1024: require('./images/logo_1024.png'),
    logoPaperang: require('./images/logo_paperang.png'),
    peak: require('./images/peak.png'),
    pullProducts: require('./images/pull_products.png'),
    // pullProducts2x: require('./images/pull_products@2x.png'),
    // pullProducts3x: require('./images/pull_products@3x.png'),
    shipjungLogo: require('./images/shipjung_logo.png'),
    storeShadowBg: require('./images/store_shadow_bg.png'),
    storeShadowBgBlack: require('./images/store_shadow_bg_black.png'),
    storeShadowBgWhite: require('./images/store_shadow_bg_white.png'),
    userIcon: require('./images/user-icon.png'),
    volumnDiscount: require('./images/volumn_discount.png'),
    // volumnDiscount2x: require('./images/volumn_discount@2x.png'),
    // volumnDiscount3x: require('./images/volumn_discount@3x.png'),
    warehousesLogo2: require('./images/warehouses-logo-2.png'),

    about: {
      fbLogo: require('./images/about/FB-f-Logo__blue_100.png'),
      iconMkpChannel: require('./images/about/icon_mkp_channel.png'),
      instagramLogo: require('./images/about/instagram-logo.png'),
      lineIcon: require('./images/about/LINE_Icon.png'),
      lineShopping: require('./images/about/line_shopping.png'),
      logoLazada: require('./images/about/logo_lazada.png'),
      logoShopee: require('./images/about/logo_shopee.png'),
      messengerIcon: require('./images/about/Messenger_Icon.png'),
      spotifyLogo: require('./images/about/spotify_logo.png'),
      tiktokLogo: require('./images/about/tiktok_logo.png'),
      xsellyLogo: require('./images/about/xselly_logo_340.png'),
    },

    banks: {
      baac: require('./images/banks/baac.png'),
      bay: require('./images/banks/bay.png'),
      bkk: require('./images/banks/bkk.png'),
      cimb: require('./images/banks/cimb.png'),
      citi: require('./images/banks/citi.png'),
      creditCard: require('./images/banks/creditcard.png'),
      default: require('./images/banks/Default.png'),
      ghb: require('./images/banks/ghb.png'),
      gsb: require('./images/banks/gsb.png'),
      hsbc: require('./images/banks/hsbc.png'),
      ibank: require('./images/banks/ibank.png'),
      icbc: require('./images/banks/icbc.png'),
      kbank: require('./images/banks/kbank.png'),
      kk: require('./images/banks/kk.png'),
      ktb: require('./images/banks/ktb.png'),
      lhbank: require('./images/banks/lhbank.png'),
      mizuho: require('./images/banks/mizuho.png'),
      promptpay: require('./images/banks/promptpay.png'),
      rabbitlinepay: require('./images/banks/rabbitlinepay.png'),
      sbmc: require('./images/banks/sbmc.png'),
      scb: require('./images/banks/scb.png'),
      tisco: require('./images/banks/tisco.png'),
      tmb: require('./images/banks/tmb.png'),
      tnc: require('./images/banks/tnc.png'),
      trcbank: require('./images/banks/trcbank.png'),
      truemoney: require('./images/banks/truemoney.png'),
      ttb: require('./images/banks/ttb.png'),
      uob: require('./images/banks/uob.png'),
      kshop: require('./images/banks/kshop.png'),
      mae_manee: require('./images/banks/mae_manee.png'),
      tung_ngern: require('./images/banks/tung_ngern.png'),
    },

    crm: {
      deepblok: require('./images/crm/deepblok.png'),
    },

    btn: {
      buyPackage: require('./images/btn/btn_buy_package.png'),
    },

    courier: {
      best: require('./images/courier/best.png'),
      dhl: require('./images/courier/dhl.png'),
      ems: require('./images/courier/ems.png'),
      flash: require('./images/courier/flash.png'),
      jt: require('./images/courier/jt.png'),
      kex: require('./images/courier/kex.png'),
      logoEcopost: require('./images/courier/logo_ecopost.png'),
      logoEms: require('./images/courier/logo_ems.png'),
      ninja: require('./images/courier/ninja.png'),
      scg: require('./images/courier/scg.png'),
      shipjung: require('./images/courier/shipjung.png'),
      spx: require('./images/courier/spx.png'),
    },

    discount: {
      discountRed: require('./images/discount/discount_red.png'),
      tagDiscount: require('./images/discount/tag_discount.png'),
    },

    logo: {
      lazada: require('./images/logo/lazada.png'),
      lineShopping: require('./images/logo/line_shopping.png'),
      peak: require('./images/logo/peak.png'),
      shopee: require('./images/logo/shopee.png'),
    },

    product: {
      addAssemblyProduct: require('./images/product/add-assembly-product.png'),
      assemblyProduct: require('./images/product/assembly-product.png'),
      bundleProduct: require('./images/product/bundle-product.png'),
      convertAssemblyProduct: require('./images/product/convert-asasembly-product.png'),
      convertBundleProduct: require('./images/product/convert-bundle-product.png'),
      deleteAssemblyProduct: require('./images/product/delete-assembly-product.png'),
      standardProduct: require('./images/product/standard-product.png'),
    },

    packgeBg: {
      bronze: require('./images/packge_bg/bronz.png'),
      gold: require('./images/packge_bg/gold.png'),
      platinum: require('./images/packge_bg/platinum.png'),
      silver: require('./images/packge_bg/silver.png'),
    },

    packgeTag: {
      bronze: require('./images/packge_tag/bronze.png'),
      free: require('./images/packge_tag/free.png'),
      gold: require('./images/packge_tag/gold.png'),
      platinum: require('./images/packge_tag/platinum.png'),
      silver: require('./images/packge_tag/silver.png'),
      trial: require('./images/packge_tag/trial.png'),
    },

    partner: {
      beam: require('./images/partner/beam.png'),
      gbpay: require('./images/partner/gbpay.png'),
      maemanee: require('./images/partner/maemanee.png'),
      scbapp: require('./images/partner/scbapp.png'),
    },

    tb: {
      tbMy0: require('./images/tb/tb_my0.png'),
      // tbMy02x: require('./images/tb/tb_my0@2x.png'),
      // tbMy03x: require('./images/tb/tb_my0@3x.png'),
      tbMy1: require('./images/tb/tb_my1.png'),
      // tbMy12x: require('./images/tb/tb_my1@2x.png'),
      // tbMy13x: require('./images/tb/tb_my1@3x.png'),
      tbNoti0: require('./images/tb/tb_noti0.png'),
      // tbNoti02x: require('./images/tb/tb_noti0@2x.png'),
      // tbNoti03x: require('./images/tb/tb_noti0@3x.png'),
      tbNoti1: require('./images/tb/tb_noti1.png'),
      // tbNoti12x: require('./images/tb/tb_noti1@2x.png'),
      // tbNoti13x: require('./images/tb/tb_noti1@3x.png'),
      tbOthers0: require('./images/tb/tb_others0.png'),
      // tbOthers02x: require('./images/tb/tb_others0@2x.png'),
      // tbOthers03x: require('./images/tb/tb_others0@3x.png'),
      tbOthers1: require('./images/tb/tb_others1.png'),
      // tbOthers12x: require('./images/tb/tb_others1@2x.png'),
      // tbOthers13x: require('./images/tb/tb_others1@3x.png'),
      tbSeller0: require('./images/tb/tb_seller0.png'),
      // tbSeller02x: require('./images/tb/tb_seller0@2x.png'),
      // tbSeller03x: require('./images/tb/tb_seller0@3x.png'),
      tbSeller1: require('./images/tb/tb_seller1.png'),
      // tbSeller12x: require('./images/tb/tb_seller1@2x.png'),
      // tbSeller13x: require('./images/tb/tb_seller1@3x.png'),
    },

    verifySlip: {
      blue: require('./images/verify_slip/blue.png'),
      greenCircle: require('./images/verify_slip/green-circle.png'),
      green: require('./images/verify_slip/green.png'),
      green0C9400: require('./images/verify_slip/green0C9400.png'),
      green5CB85C: require('./images/verify_slip/green5CB85C.png'),
      grey: require('./images/verify_slip/grey.png'),
      red: require('./images/verify_slip/red.png'),
      yellow: require('./images/verify_slip/yellow.png'),
    },
  },
  sounds: {
    barcode_sound: require('./sounds/barcode_sound.mp3'),
    ring_error: require('./sounds/ring_error.mp3'),
    ring_success: require('./sounds/ring_success.mp3'),
  },
}

export default assetPaths
